import classNames from 'classnames'
import DiscoveryHubSearchTermSugestion from 'src/components/Icons/DiscoveryHubSearchTermSugestion'
import SearchTermMagnifyingGlass from 'src/components/Icons/SearchTermMagnifyingGlass'
import SearchHistoryIcon from 'src/components/Icons/SearchHistoryIcon'
import { useMobile } from 'src/hooks/useMobile'

type Props = {
  label: string
  term?: string
  type: 'list' | 'suggestion'
  onClick: (term: string) => void
  userSearchedTerms?: boolean
}
export function SuggestionItem({
  term,
  label,
  type,
  onClick,
  userSearchedTerms,
}: Props) {
  const labelFormat = term
    ? label.replace(
        term,
        `<strong data-testid="elementTerm" class="desktop-body-semibold-text3">${term}</strong>`
      )
    : label

  const { isMobile } = useMobile()

  return (
    <button
      data-testid="linkList"
      className={classNames(
        'desktop-body-regular-text3 text-sm text-restructure-primary font-normal whitespace-nowrap flex items-center pr-[4px]',
        {
          'hover:bg-restructure-background-secondary flex-1x restructure-small-desktop:flex restructure-small-desktop:items-center':
            type === 'list',
        }
      )}
      onClick={() => onClick(label)}
    >
      {type === 'list' && term !== '' && (
        <SearchTermMagnifyingGlass
          width={!isMobile ? 20 : 17}
          height={!isMobile ? 20 : 16}
        />
      )}
      {userSearchedTerms && term === '' && <SearchHistoryIcon />}
      {type === 'suggestion' && term === '' && !userSearchedTerms && (
        <DiscoveryHubSearchTermSugestion />
      )}
      <p className="ml-2" dangerouslySetInnerHTML={{ __html: labelFormat }} />
    </button>
  )
}
